import { BASE_ENDPOINT } from "../../../endpoint";

export const downloadGroupReportService = async (
	token: string,
	type: string
): Promise<Blob> => {
	const reportType = type || "excel";
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/customerservice/all/group/report/download?type=${encodeURIComponent(
				reportType
			)}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					Accept:
						reportType === "pdf"
							? "application/pdf"
							: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				},
			}
		);
		if (!response.ok) {
			console.error("Failed to download group report");
			throw new Error("Failed to download group report");
		}
		const blob = await response.blob();
		return blob;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
